import React from 'react';
export const Discovery = () => {
  return <section className="w-full bg-white py-10 px-4" data-id="element-64">
      <div className="max-w-4xl mx-auto" data-id="element-65">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-66">
          La Découverte Révolutionnaire Venue d'Allemagne
        </h2>
        <div className="bg-blue-50 p-6 rounded-lg shadow-sm mb-8" data-id="element-67">
          <div className="flex flex-col md:flex-row gap-6 mb-6" data-id="element-68">
            <div className="md:w-1/3" data-id="element-69">
              <img src="https://images.unsplash.com/photo-1551190822-a9333d879b1f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Docteur en conférence médicale" className="w-full h-auto rounded-md shadow-sm" data-id="element-70" />
            </div>
            <div className="md:w-2/3" data-id="element-71">
              <p className="text-gray-700 mb-4" data-id="element-72">
                En 2019, lors d'un congrès médical à Berlin, j'ai rencontré le
                Dr. Hans Weber, spécialiste de la neuropathie à l'Université de
                Munich.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-73">
                Il m'a posé une question qui a changé ma vision :
              </p>
              <p className="text-gray-700 mb-4 italic font-bold" data-id="element-74">
                "François, pourquoi essayons-nous de masquer la douleur au lieu
                de relancer la circulation et stimuler la régénération nerveuse
                ?"
              </p>
              <p className="text-gray-700" data-id="element-75">
                Dr. Weber avait développé une approche révolutionnaire : au lieu
                d'une seule thérapie, combiner 4 technologies validées pour
                créer un effet synergique.
              </p>
            </div>
          </div>
          <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-76">
            Les 4 Thérapies Synergiques :
          </h3>
          <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-77">
            <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-78">
              <h4 className="font-bold text-blue-800 mb-2" data-id="element-79">
                1. Électrostimulation (EMS)
              </h4>
              <p className="text-gray-700" data-id="element-80">
                Réactive la conduction nerveuse comme un "défibrillateur pour
                vos pieds"
              </p>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-81">
              <h4 className="font-bold text-blue-800 mb-2" data-id="element-82">
                2. Thermothérapie
              </h4>
              <p className="text-gray-700" data-id="element-83">
                La chaleur ciblée dilate vos vaisseaux, permettant aux
                nutriments d'atteindre vos nerfs affamés
              </p>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-84">
              <h4 className="font-bold text-blue-800 mb-2" data-id="element-85">
                3. Massage Thérapeutique
              </h4>
              <p className="text-gray-700" data-id="element-86">
                Stimule la circulation lymphatique, évacue les toxines qui
                "étouffent" vos nerfs
              </p>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-87">
              <h4 className="font-bold text-blue-800 mb-2" data-id="element-88">
                4. Photobiomodulation
              </h4>
              <p className="text-gray-700" data-id="element-89">
                Lumière rouge utilisée par la NASA : "réveille" les cellules
                nerveuses endommagées
              </p>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg mb-6" data-id="element-90">
            <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-91">
              L'Effet Synergique Expliqué :
            </h3>
            <p className="text-gray-700 mb-4 italic" data-id="element-92">
              "Imaginez un jardin en sécheresse. Vous pouvez arroser
              (circulation), enlever les mauvaises herbes (toxines), ajouter de
              l'engrais (stimulation), et donner de la lumière
              (photobiomodulation).
            </p>
            <p className="text-gray-700 italic" data-id="element-93">
              Chaque action isolée aide un peu. Les quatre ensemble ressuscitent
              le jardin."
            </p>
          </div>
          <p className="text-gray-700 font-bold text-center" data-id="element-94">
            Dr. Weber a testé cette approche sur 340 patients en Allemagne.
            Résultats : 89% ont retrouvé au moins 50% de leur sensibilité en 8
            semaines.
          </p>
        </div>
      </div>
    </section>;
};